import * as React from "react";

import type {AsyncApolloResultShape} from "@khan/data-gql-apollo";

import ApolloFastlyQuery from "#data-access/gql/apollo-fastly-query.tsx";
import ApolloQuery from "#data-access/gql/apollo-query.tsx";

import {
    GET_OFFICIAL_CLARIFICATIONS_WITH_REPORTER_QUERY,
    GET_OFFICIAL_CLARIFICATIONS_WITHOUT_REPORTER_QUERY,
    type OfficialClarificationsData,
} from "./official-clarifications-queries.ts";

type OfficialClarificationsQueryProps = {
    youtubeId: string;
    // We can cache these results via Fastly, but you won't get user data
    // about the reporters because user data can't be a part of cached
    // queries
    cacheWithoutReporters: boolean;
    children: (
        props: AsyncApolloResultShape<OfficialClarificationsData>,
    ) => React.ReactNode;
};

const OfficialClarificationsQuery = function ({
    youtubeId,
    cacheWithoutReporters,
    children,
}: OfficialClarificationsQueryProps): React.ReactElement {
    if (cacheWithoutReporters) {
        // In order for this to be cached, we can't include user
        // data (reporter) in the query
        return (
            <ApolloFastlyQuery
                query={GET_OFFICIAL_CLARIFICATIONS_WITHOUT_REPORTER_QUERY}
                variables={{youtubeId}}
            >
                {children}
            </ApolloFastlyQuery>
        );
    }

    return (
        <ApolloQuery
            query={GET_OFFICIAL_CLARIFICATIONS_WITH_REPORTER_QUERY}
            variables={{youtubeId}}
            fetchPolicy="cache-first"
        >
            {children}
        </ApolloQuery>
    );
};
export default OfficialClarificationsQuery;
